import { render, staticRenderFns } from "./csv-import.vue?vue&type=template&id=71bdfe8d&scoped=true&"
import script from "./csv-import.vue?vue&type=script&lang=js&"
export * from "./csv-import.vue?vue&type=script&lang=js&"
import style0 from "./csv-import.vue?vue&type=style&index=0&id=71bdfe8d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71bdfe8d",
  null
  
)

export default component.exports